import styled from 'styled-components';
import theme from '@shared/assets/theme/globalTheme';
export const TabButton = styled.div.withConfig({
  displayName: "TabwithoutSlidestyle__TabButton",
  componentId: "sc-ky2yh0-0"
})(["", " &:hover{border-color:", ";}&.active{", " border-color:", " !important;background-color:", ";}@media (max-width:", "){", " &:hover{", "}&.active:hover{border-color:", " !important;}}"], {
  "width": "fit-content",
  "cursor": "pointer",
  "borderRadius": "9999px",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 206 206 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.375rem",
  "paddingBottom": "0.375rem",
  "fontSize": "1.5rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
}, ({
  $themeColor
}) => $themeColor ?? theme.colors.orange[50], {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, ({
  $themeColor
}) => $themeColor ?? theme.colors.orange[50], ({
  $themeColor
}) => $themeColor ?? theme.colors.orange[50], ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "21px"
}, {
  "--tw-border-opacity": "1 !important",
  "borderColor": "rgb(206 206 206 / var(--tw-border-opacity, 1)) !important"
}, ({
  $themeColor
}) => $themeColor ?? theme.colors.orange[50]);